import * as types from './actionTypes';
import {renuevaTokenAccion} from '../util';
import {Api} from '../api/Api';
import toastr from 'toastr';


export function showModalFinSession() {		
	
	return {
		type: types.SHOW_MODAL_FIN_SESSION
	};
}

export function renueva(user) {
  return {type: types.RENOVAR_SESSION, datos:user};
}


export function renuevaSessionUser(){
    return dispatch => {
        return renuevaTokenAccion(this).then( (user)=>{ 
            dispatch(renueva(user));
        })
        .catch(error=>{
          toastr.info("Registrate para participar en los cursos.");
             dispatch(renueva(null));
        });
    };
	
}

export function initTimer() {
//debugger;
  //console.log("Action initTimer");    
    
  return {type: types.INIT_TIMER};    
}

/*
export function addUser(user){
	return {type: types.ADD_TOKEN, datos:user};
}
*/

/*
export function renovarSessionSuccess() {		
	return {
		type: types.RENOVAR_SESSION
	};
}

export function renovarSession() {		
	
  return dispatch => {	
    return Api().FinSessionApi.renovarSession().then(() => {
      dispatch(renovarSessionSuccess());
    }).catch(error => {
		dispatch(ajaxCallError());
      throw(error);
    });
  };
}
*/

